import React, { useEffect, useState } from "react";
import Product from "./Product";
import { Link } from "react-router-dom";
import Loading from "../Shared/Loading";

const Products = () => {
  const [products, setParts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    fetch("https://mbababd24.onrender.com/partHome")
      .then((res) => res.json())
      .then((data) => {
        setParts(data);
        setIsLoading(false);
      });
  }, []);

  console.log(products);
  if (isLoading) {
    return <Loading></Loading>;
  }
  return (
    <div className="my-10">
      <h4 className="lg:text-5xl text-4xl font-bold text-accent text-center my-12">
        Delightful deals for everyone
      </h4>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {products.map((carPart) => (
          <Product
            key={carPart._id}
            carPart={carPart}
            // isLoading={isLoading}
          ></Product>
        ))}
      </div>

      <div className="text-center py-10 mx-12">
        <Link to="/shops">
          {" "}
          <button
            className="btn  border-2 border-white shadow-2xl btn-block text-accent capitalize bg-gradient-to-r from-secondary-400 to-primary-500 hover:from-green-500 hover:to-blue-500 font-bold"
            style={{ fontFamily: "Roboto" }}
          >
            🚀 Shop all deals 🚀
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Products;
